export default "__VITE_ASSET__Cui3SItJ__"